import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Button from '@mui/material/Button';

import { yellow } from '@mui/material/colors';
import { getDisplaySize } from "../../utils/Items";
import { Dialog, Typography } from "@mui/material";

// 商品明細削除ダイアログ
export default function DeleteProductDialog({open, onCloseDialog, productDetail, deleteAction}) {

    const nullProductData ={
      productName: "",
      origin: "",
      rank: "",
      productClass: "",
      weight: "",
      weightUnit: "",
      orderingUnit: "",
      supplier : ""
    }
  
    const {productName, origin, rank, productClass, weight, weightUnit, orderingUnit, supplier} = productDetail ? productDetail : nullProductData;
  

    const onClickDelete = (event) => {
      deleteAction();
      alert(
        "以下の商品明細を削除しました。\n"
        + `商品: ${productName}\n`
        + `産地: ${origin}\n`
        + `発注規格: ${getDisplaySize(rank, productClass, weight, weightUnit)}\n`
        + `発注単位: ${orderingUnit || ""}\n`
        + `仕入先: ${supplier || ""}`
      );
      onCloseDialog(event);
    }
  
    const onCloseCancel = (event) => {
      onCloseDialog(event);
    }
  
    return(
      <Dialog open={open} onClose={onCloseCancel}>
        <Box padding={2} minWidth={400}>
          <Typography fontSize={20} fontWeight={700}>削除</Typography>
          <Box marginTop={2} marginBottom={1}>
            <Typography>商品一覧から、以下の商品明細を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography fontSize={20}>商品:&nbsp;{productName}</Typography>
              <Typography fontSize={20}>産地:&nbsp;{origin}</Typography>
              <Typography fontSize={20}>発注規格:&nbsp;{getDisplaySize(rank, productClass, weight, weightUnit)}</Typography>
              <Typography fontSize={20}>発注単位:&nbsp;{orderingUnit}</Typography>
              <Typography fontSize={20}>仕入先:&nbsp;{supplier}</Typography>
            </Box>
          </Box>
  
          <Grid container>
            <Grid item xs textAlign='center'>
              <Button
                variant="contained"
                color='error'
                onClick={onClickDelete}
              >
                削除
              </Button>
            </Grid>
            <Grid item xs textAlign='center'>
              <Button variant="outlined" onClick={onCloseCancel}>戻る</Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    )
  }
  